import React from 'react';
import Resources from '../../../pages/Resources';
import GettingStarted from '../../../pages/GettingStarted';
import MarketingStrategies from '../../../pages/MarketingStrategies';
import SEOGuide from '../../../pages/SEOGuide';
import CaseStudies from '../../../pages/CaseStudies';
import GrowthTips from '../../../pages/GrowthTips';
import BestPractices from '../../../pages/BestPractices';
import Careers from '../../../pages/Careers';

export const resourcesRoutes = [
  { path: '/resources', element: <Resources /> },
  { path: '/resources/getting-started', element: <GettingStarted /> },
  { path: '/resources/marketing-strategies', element: <MarketingStrategies /> },
  { path: '/resources/seo-guide', element: <SEOGuide /> },
  { path: '/resources/case-studies', element: <CaseStudies /> },
  { path: '/resources/growth-tips', element: <GrowthTips /> },
  { path: '/resources/best-practices', element: <BestPractices /> },
  { path: '/careers', element: <Careers /> }
];
